const theme = {
  bgColor: '#F7F7F7',
  mainBlueColor: '#1D9BF0',
  mainHoverBlueColor: '#1A8CD8',
  mainWhiteBlueColor: '#8ECDF7',
  blackGrayColor: 'black',
  blackGrayHoverColor: '#272C30',
  greenColor: '#BFE38A',
  baseBorderStyle: '1px solid rgba(0, 0, 0, 0.1)',
};

export default theme;
